var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#231F20;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,44.2h-4.5c-3.6,0-6.5-2.9-6.5-6.5v-7c0-3.6,2.9-6.5,6.5-6.5h4.5V44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,44.2h4.5c3.6,0,6.5-2.9,6.5-6.5v-7c0-3.6-2.9-6.5-6.5-6.5h-4.5V44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,24.1c0,0,2.1-19.3-20.8-19.3S11.2,24.1,11.2,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6,24.1c0,0,1-15.3-16.8-15.3h0.4C14,8.9,15.4,24.1,15.4,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.7,57.6c1.4,1.5,3.5,2,5.4,1.3l5.7-2.1c1.5-0.5,1.9-2.4,0.8-3.5l-3.4-3.6c-0.7-0.7-1.7-0.9-2.5-0.5 l-5.5,2.7L29,39.9l3.1-5.3c0.5-0.8,0.4-1.9-0.3-2.6l-3.4-3.6c-1.1-1.1-2.9-0.8-3.6,0.6l-2.5,5.6c-0.8,1.8-0.5,4,0.9,5.4L39.7,57.6z "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.4,
    y1: 46.9,
    x2: 31.1,
    y2: 55.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36,
    y1: 39,
    x2: 41.5,
    y2: 45.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,22.6v-6.8c0-0.4,0.1-0.6,0.2-0.8s0.4-0.3,0.6-0.3c0.3,0,0.5,0.1,0.6,0.3s0.2,0.4,0.2,0.8v6.8c0,0.4-0.1,0.6-0.2,0.8 s-0.4,0.3-0.6,0.3c-0.2,0-0.5-0.1-0.6-0.3S26.5,23,26.5,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,15.8l3.3,5.1v-5.1c0-0.3,0.1-0.6,0.2-0.7s0.3-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.7v6.8 c0,0.8-0.3,1.1-0.9,1.1c-0.2,0-0.3,0-0.4-0.1s-0.2-0.1-0.4-0.2s-0.2-0.2-0.3-0.3s-0.2-0.3-0.3-0.4l-3.3-5v5c0,0.3-0.1,0.6-0.2,0.7 s-0.3,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.3s-0.2-0.4-0.2-0.7v-6.6c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.3,0.4-0.4s0.4-0.2,0.6-0.2 c0.2,0,0.3,0,0.4,0.1s0.2,0.1,0.3,0.2s0.2,0.2,0.3,0.3S32.3,15.7,32.4,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIn);
export default __webpack_public_path__ + "static/media/call-in.ee1543c90f42e385ad3eba848ca4ff96.svg";
export { ForwardRef as ReactComponent };